import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const ToolbarContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.primary[900],
}));
